import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { useState } from 'react';
import classes from "./style.module.scss";

const sortingOptions = [
  { label: 'Name', value: 'name' },
  { label: 'Type', value: 'type' },
  { label: 'Date', value: 'date' },
];

const SortingDropdown = ({ onSortChange }) => {
  const [selectedSort, setSelectedSort] = useState(sortingOptions[0]);

  const handleSortChange = (option) => {
    setSelectedSort(option);
    if (onSortChange) {
      onSortChange(option);
    }
  };

  return (
    <Menu as="div" className="relative inline-block text-left">
      <div className={`${classes.sorting}`}>
        <MenuButton className="inline-flex w-full justify-center items-center gap-x-1.5 rounded-md bg-white px-2 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 h-[48px] text-gray-900">
          Sort by <span className="font-bold">{selectedSort.label}</span>
          <ChevronDownIcon aria-hidden="true" className="-mr-1 h-5 w-5 text-gray-400" />
        </MenuButton>
      </div>

      <MenuItems className="absolute right-0 z-10 mt-2 w-44 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
        <div className="py-1">
          {sortingOptions.map((option) => (
            <MenuItem key={option.value}>
              {({ active }) => (
                <button
                  onClick={() => handleSortChange(option)}
                  className={`block w-full text-left px-4 py-2 text-sm text-gray-700 ${
                    active ? 'bg-gray-100 text-gray-900' : ''
                  }`}
                >
                  {option.label}
                </button>
              )}
            </MenuItem>
          ))}
        </div>
      </MenuItems>
    </Menu>
  );
};

export default SortingDropdown;
